
const SiteSearch = require('./siteSearch');

document.addEventListener('click', onSearchClick);
document.addEventListener('click', onDropdownTogglerClick);
document.addEventListener('click', onNavToggle);

let searchInitialized = false;

// let sitetoolbarClassName = document.documentElement.lang === 'ru' ? 'sitetoolbar' : 'sitetoolbar-light';
let sitetoolbarClassName = 'sitetoolbar';
let sitetoolbarSelector = '.' + sitetoolbarClassName;

let siteSearch;

function onDropdownTogglerClick(event) {
  if (!event.target.closest) return; // svg
  let toggler = event.target.closest('[data-dropdown-toggler]');
  if (!toggler) return;
  toggler.nextElementSibling.style.display = toggler.nextElementSibling.offsetWidth ? 'none' : 'block';
}

function onNavToggle(event) {
  if (!event.target.closest) return; // svg
  let toggler = event.target.closest('.sitetoolbar__nav-toggle');
  if (!toggler) return;
  event.target.classList.toggle('sitetoolbar__nav-toggle_active');
  document.querySelector('.sitetoolbar').classList.toggle('sitetoolbar_menu_open');
}

// toggle search on/off, autofocus on input when "on"
function onSearchClick(event) {
  if (!event.target.closest) return; // svg

  if (!event.target.closest('.sitetoolbar__search-toggle')) {
    return;
  }

  let searchElem = document.querySelector('.sitetoolbar__search-content');

  if (!siteSearch) {
    siteSearch = new SiteSearch({ elem: searchElem });
    siteSearch.show();
  }
}
